import { render, staticRenderFns } from "./PushAddOrEdit.vue?vue&type=template&id=387b0050&"
import script from "./PushAddOrEdit.vue?vue&type=script&lang=js&"
export * from "./PushAddOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./PushAddOrEdit.vue?vue&type=style&index=0&id=387b0050&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports